import Helper from 'src/support/Helper';

class ResponseMaker {
    data = [];
    data_to_send = {
        totalForecastList: 0,
        forecastList: [],
        forecastDetailList: [],
        forecastCounts: {
            total: 0,
            nonConstraint: 0,
            constraint: 0
        },
        lastForecastReceivedDate: '',
        forecastDateColumns: [],
    };

    constructor(data) {
        this.data = data;
    }

    process = async () => {
        if (this.data.headerData) {
            this.data_to_send.forecastCounts.total = this.data.headerData.total ? this.data.headerData.total : 0
            this.data_to_send.forecastCounts.nonConstraint = this.data.headerData.nonConstraint ? this.data.headerData.nonConstraint : 0
            this.data_to_send.forecastCounts.constraint = this.data.headerData.constraint ? this.data.headerData.constraint : 0

            this.data_to_send.lastForecastReceivedDate = this.data.headerData.lastForecastReceivedDate ? Helper.dateFormatFromString(this.data.headerData.lastForecastReceivedDate,true) : ''
        }

        if (this.data.additionalColumns && this.data.additionalColumns.dateColumns && this.data.additionalColumns.dateColumns.length > 0) {
            let dateRes = []
            this.data.additionalColumns.dateColumns.map((v) => {
                dateRes.push(Helper.dateFormatFromString(v.replace(/\./g, ''),true))
            })
            this.data_to_send.forecastDateColumns = dateRes
        }

        if (this.data.lineItems && this.data.lineItems.length > 0) {
            let lineItemsListRes = {}
            let lineItemsDetailRes = {}
            let lineItems = this.data.lineItems

            lineItems.map((v, i) => {
                let uniqueID = v.itemHeader.customerPartNumber + Helper.UUID()
                if (v.itemHeader) {
                    lineItemsListRes[uniqueID] = { ...v.itemHeader, 'uniqueID': uniqueID }
                }

                if (v.itemDetails) {
                    lineItemsDetailRes[uniqueID] = v.itemDetails
                }
            })

            this.data_to_send.forecastList = lineItemsListRes
            this.data_to_send.forecastDetailList = lineItemsDetailRes
        }

        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}

export default ResponseMaker;